import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Page} from "../components/add-edit-page/model/page";
import {News} from "../components/add-edit-news/model/news";

@Injectable()
export class NewsService {
  previewNewsContentKey: string = 'previewNewsContent';
  constructor(private _http: HttpClient) {
  }

  getNewsContent(pageId: number) {
    return this._http.post<News>('api/s/news/get', pageId);
  }

  addNewNews(params: any) {
    console.log('PagesService addNewPage' , params);
    return this._http.post<any>('api/m/news/add', params);
  }

  editNews(params: any) {
    return this._http.post<any>('api/m/news/edit', params);
  }

  publishNews(params: any) {
    return this._http.post<any>('api/m/news/publish', params);
  }

  archiveNews(pageId: any) {
    return this._http.post<any>('api/m/news/archive', pageId);
  }

  recoverNews(pageId: any) {
    return this._http.post<any>('api/m/news/recover', pageId);
  }

  setPreviewNewsContent(news: News) {
    sessionStorage.setItem(this.previewNewsContentKey, JSON.stringify(news));
  }
  getPreviewNewsContent(): any {
    let page : Page = JSON.parse(sessionStorage.getItem(this.previewNewsContentKey));
    return page;
  }
  removePreviewNewsContent() {
    sessionStorage.removeItem(this.previewNewsContentKey);
  }

  getNewsSectionModerators() {
    return this._http.post<any[]>('api/m/news/newsModerators', null);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/moderator/services/news.service.ts